module.exports = __webpack_public_path__ + "static/media/web-ats-02.2d451ba0.jpg";